module.exports = __webpack_public_path__ + "static/media/r5.f2849b82.jpg";